import cabri from "../app/cabri-app";
import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";
import {RenderableMesh} from "./renderable-mesh.js";

const subplaneTypes =   {
  UNDEFINED_SUBPLANE:0,
  HALF_PLANE:1,
  SECTOR:2,
  TRIANGLE:3,
  CONVEX_POLYGON:4,
  GENERAL_POLYGON:5,
  GENERAL:6
};

class Subplane extends RenderableMesh {

  constructor(objectId) {
    super(objectId, "subplane");
  }

  updateFromPeer()
  {
    const subplaneType = cabri.emsc.getSubplaneType(this.objectId);
    super.drawDim1 = subplaneType !== subplaneTypes.HALF_PLANE;
    super.drawDim2 = true;
    return super.updateFromPeer();
  }

}

export {Subplane}